module.exports = __webpack_public_path__ + "media/images/admin/icons/briefcase-21248a068c385cec74542746ea8c5e8c.svg";